<div class="gb-archive-user-dialog">
  <div class="gb-dialog-header">
    <h1 translate="USER_ACCOUNTS.ARCHIVE_DIALOG.TITLE"></h1>
    <button mat-icon-button mat-dialog-close>
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>

  <div class="gb-dialog-content">
    <div class="callout-warning">
      <gb-icon icon="warning"></gb-icon>
      <span translate="USER_ACCOUNTS.ARCHIVE_DIALOG.WARNING"> </span>
    </div>

    <div class="user-info">
      @let selectedUserAccount = selectedUserAccount$ | async;

      <div class="info-item">
        <span translate="USER_ACCOUNTS.ARCHIVE_DIALOG.NAME" class="label"></span>
        <span>{{ selectedUserAccount | gbDisplayName }}</span>
      </div>
      @if (selectedUserAccount?.email) {
        <div class="info-item">
          <span translate="USER_ACCOUNTS.ARCHIVE_DIALOG.EMAIL" class="label"></span>
          <span>{{ selectedUserAccount?.email }}</span>
        </div>
      }
      @if (selectedUserAccount?.phone_number) {
        <div class="info-item">
          <span translate="USER_ACCOUNTS.ARCHIVE_DIALOG.PHONE" class="label"></span>
          <span>{{ selectedUserAccount?.phone_number }}</span>
        </div>
      }
    </div>

    <ul>
      @for (bullet of bullets; track bullet) {
        <li [innerHTML]="bullet | translate"></li>
      }
    </ul>
  </div>

  <div class="gb-flex-button-container gb-dialog-actions-container">
    <button mat-stroked-button translate="CANCEL" mat-dialog-close></button>
    <button [disabled]="!(saved$ | async)" mat-flat-button class="warn" (click)="archiveUser()">
      <gb-button-loader [loaded$]="saved$">
        <span translate="USER_ACCOUNTS.ARCHIVE_DIALOG.SUBMIT"></span>
      </gb-button-loader>
    </button>
  </div>
</div>
